var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"clearable":"","filterable":"","placeholder":"请选择"},model:{value:(_vm.agency_name),callback:function ($$v) {_vm.agency_name=$$v},expression:"agency_name"}},_vm._l((_vm.AgencyList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.id+'>'+item.user_name+'>'+item.nickname,"value":item.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }